import { Typography } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

type CategoryPromptsProps = {
  promptyKeyName?: string;
  categoryPrompts?: string[];
  programDescription: string;
};

type CATEGORY_NAME =
  | 'additional_benefit'
  | 'reaction'
  | 'learning'
  | 'application'
  | 'impact'
  | 'roi';
const getPrompts = (promptyKeyName: CATEGORY_NAME) => {
  const prompts: Record<CATEGORY_NAME, string[]> = {
    reaction: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.REACTION_PROMPT_1'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.REACTION_PROMPT_2'
      ),
    ],
    application: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.APPLICATION_PROMPT_1'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.APPLICATION_PROMPT_2'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.APPLICATION_PROMPT_3'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.APPLICATION_PROMPT_4'
      ),
    ],
    impact: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.IMPACT_PROMPT_1'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.IMPACT_PROMPT_2'
      ),
    ],
    roi: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.ROI_PROMPT_1'
      ),
    ],
    learning: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.LEARNING_PROMPT_1'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.LEARNING_PROMPT_2'
      ),
    ],
    additional_benefit: [
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.ADD_ADDITIONAL_BENEFIT_MODAL.PROMPTS.SOURCE'
      ),
      intl.get(
        'PROGRAM_PAGE.STRATEGY_PAGE.ADD_ADDITIONAL_BENEFIT_MODAL.PROMPTS.OTHER'
      ),
    ],
  };
  return prompts[promptyKeyName.toLowerCase() as CATEGORY_NAME] || [];
};
const CategoryPrompts = ({
  promptyKeyName,
  categoryPrompts,
  programDescription,
}: CategoryPromptsProps) => {
  return (
    <div className='w-5/12'>
      <Typography
        variant='body'
        weight='medium'
        className='pb-2'
        data-testid='create-objective-modal_prompts-label'
      >
        {intl.get('PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.PROMPTS')}
      </Typography>
      <ul
        className='list-disc ml-4'
        data-testid='create-objective-modal_prompts-list'
      >
        {getPrompts(
          (promptyKeyName as 'reaction' | 'learning') || 'reaction'
        ).map((prompt, index) => (
          <li key={index} className='text-base'>
            {prompt}
          </li>
        ))}
      </ul>

      <Typography variant='body' weight='medium' className='pb-2 pt-4'>
        {intl.get(
          'PROGRAM_PAGE.STRATEGY_PAGE.OBJECTIVE.ADD_OBJECTIVE.PROGRAM_DESCRIPTION'
        )}
      </Typography>
      <Typography
        variant='body'
        data-testid='create-objective-modal_category-description'
      >
        {programDescription}
      </Typography>
    </div>
  );
};

export default CategoryPrompts;
